import { Component } from '@angular/core';

@Component({
  selector: 'app-success-stores',
  templateUrl: './success-stores.component.html',
  styleUrls: ['./success-stores.component.scss']
})
export class SuccessStoresComponent {
  selectedTab: string = 'tab_1';

  selectTab(tabId: string) {
    this.selectedTab = tabId;
  }
}
